import { render, staticRenderFns } from "./Tariff.vue?vue&type=template&id=12f80c6e&scoped=true"
import script from "./Tariff.vue?vue&type=script&lang=js"
export * from "./Tariff.vue?vue&type=script&lang=js"
import style0 from "./Tariff.vue?vue&type=style&index=0&id=12f80c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f80c6e",
  null
  
)

export default component.exports